$(document).ready(function () {
        
    /*_____________________________[ menu v1.2.1 ]*/
    var $root = $("#position-menu-quantalys");
    $(function () {        

        //setSubMenuPosition();
        setBetterSubMenuPosition();
        updateActiveElt();

      

        // save the menu state
        $root.find(".dropdown a").on("click", function (e) { // $root.find(".dropdown .dropdown-sous-menu").on("click", function (e) { // 

            e.preventDefault();
            var idx;
            var keyArray = [];
            if (isSubMenuElt(this)) {
                idx = $.inArray($(this).get(0), $('div[class^="submenu-"] > a'));
                if (idx != -1)
                    keyArray.push(idx);

                idx = $.inArray($('a[class$="active"]').get(0), $(".dropdown > a"));
                if (idx != -1)
                    keyArray.push(idx);
            }
            else {
                idx = $.inArray($(this).get(0), $(".dropdown > a"));
                if (idx != -1)
                    keyArray.push(idx);
            }

            if (isSubMenuElt(this))
                activateMenuSubElt(this);
            else
                activateMenuElt(this);

            window.sessionStorage.setItem('data-active-menu', JSON.stringify(keyArray));

            if (typeof $(this).attr("href") != "undefined")
                window.location = $(this).attr("href");
        });

        // upper menu event listener
        $(".dropbtn").on("click", function (e) {            
            var targetedElt = $(this);
            var $submenu = $(targetedElt).next(".submenu-position")
            var isDisplayed = $submenu.hasClass("show");

            hideSubMenu();

            if (!isDisplayed) {
                displaySubMenu(targetedElt);
            }
        });
    });

    function activateMenuElt(elt) {
        resetSelectedSubMenu();
        $(".dropdown > .active").removeClass("active");
        $(elt).addClass("active");
    }

    function activateMenuSubElt(elt) {
        resetSelectedSubMenu();
        $(elt).addClass("active");
    }

    function displaySubMenu(elt) {        
        if ($(elt).next().get(0) === $(elt).next(".submenu-position").get(0)) {
            $(elt).next(".submenu-position").addClass("show");            
        }            
    }

    function hideSubMenu() {
        $root.find(".show").removeClass("show");
    }

    function resetSelectedSubMenu() {
        $(".submenu-position .active").removeClass("active");
    }

    function resetAll() {
        hideSubMenu();
        $(".active").removeClass("active");
        window.sessionStorage.setItem('data-active-menu', "[]");
    }

    function isSubMenuElt(elt) {
        var parent = $($(elt).parent('div[class^="submenu-"]').get(0));
        if (typeof parent != "undefined" && parent.length > 0)
            return true;
        else
            return false;
	}

	function setBetterSubMenuPosition() {
		$(".submenu-position", $root.find("table")).each(function (i, elt) {
			var headerLogoWidth = 169;
			$(".submenu-position", $root.find(".dropdown")).css("margin-left", "-" + headerLogoWidth + "px");
		});
	}

    function setSubMenuPosition() {      
        var marge = 25;
        
        // set up the sub menu parent width regardi its children
        $(".submenu-offset", ".dropdown").each(function (i, elt0) {
            var widthSum = marge;
            $("a", $(elt0)).each(function (i, elt) {
                widthSum += $(elt).outerWidth() + 1;
            });            
            $(elt0).css({ "width": widthSum +"px"});
        });

        // text align left
        var subMenuEltWidth = WidthDisplay($(".dropbtn").next(".submenu-position"), $(".dropbtn").parent(".dropdown").get(0));

        $(".submenu-position", $root.find("table")).each(function (i, elt) {
            var headerLogoWidth = 169;
            $(".submenu-position", $root.find(".dropdown")).css("margin-left", "-" + headerLogoWidth + "px");
        });

        // set up the sub menu position regarding its parent
        $(".dropbtn").each(function (i, elt0) {
            var targetedElt = $(elt0);
            var $submenu = $($(targetedElt).next());

            if (isSubMenuElt($(".submenu-offset > a", $submenu).get(0))) {
                var posXParent = $(targetedElt).offset().left;
                var widthParent = $(targetedElt).outerWidth();
                var widthSubParent = $(".submenu-offset", $submenu).outerWidth();
                var positionSubMenu = $submenu.offset().left;
                var menuQuantalysWidth = $(targetedElt.parent(".dropdown").get(0)).width();

                // update the sub menu position
                var offsetMenu = GetOffsetSubmenu(posXParent, widthParent, widthSubParent, positionSubMenu, menuQuantalysWidth);
                $(".submenu-offset", $submenu).css({ "margin-left": offsetMenu });
            }
        });
    }

    function GetOffsetSubmenu(posXParent, widthParent, widthSubParent, posXSubParent, containerWidth) {
        var offsetLeft = -(posXSubParent + widthSubParent / 2 - posXParent - widthParent);
        var marginDiv = 10;

        //Cas extrême coté gauche        
        if (offsetLeft < 0) {
            return marginDiv;
        }
        
        //Cas extrême coté droit 
        var leftX = $($(".submenu-position", $root.find(".dropdown")).get(0)).offset().left;
        if ((posXParent - leftX + widthSubParent / 2) > containerWidth) {
            return offsetLeft - widthSubParent / 2;
        }        

        return offsetLeft;
    }

    // set the sub menu position
    function WidthDisplay(enfant, parent) {
        var position = $(parent).css("position");
        var visibility = $(parent).css("visibility");
        var display = $(parent).css("display");

        var style = $(parent).attr("style");

        $(parent).css({ "position": "absolute", "visibility": "hidden", "display": "block" });
        var width = $(enfant).width();
        $(parent).removeAttr("style");
        $(parent).attr("style", style);
        return width;
    }

    // active back the previously selected menu and sub menu
    function updateActiveElt() {

        var sessionJSONContent = window.sessionStorage.getItem('data-active-menu');
        var menuEltToAvtivateIDs;

        if (typeof sessionJSONContent != "undefined")
            menuEltToAvtivateIDs = JSON.parse(sessionJSONContent);

        if (menuEltToAvtivateIDs != null && menuEltToAvtivateIDs.length > 0) {
            var foundSubElt;
            var foundElt;
            if (menuEltToAvtivateIDs.length > 1) {
                foundSubElt = $(".submenu-position a").get(menuEltToAvtivateIDs[0]);
                foundElt = $(".dropbtn").get(menuEltToAvtivateIDs[1]);                
            }
            else{
                foundElt = $(".dropbtn").get(menuEltToAvtivateIDs[0]);
            }
            
            if (typeof foundElt != "undefined")
                activateMenuElt(foundElt);
            if (typeof foundSubElt != "undefined") {
                displaySubMenu(foundElt);
                activateMenuSubElt(foundSubElt);
            }

        }
    }


});
